import React from 'react';

const UserDataDeletion = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">User Data Deletion</h1>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Your Right to Delete Data</h2>
            <p className="mb-4">
              You have the right to request deletion of your personal data at any time. This page 
              explains how to request data deletion and what happens when you do.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">How to Request Data Deletion</h2>
            <p className="mb-4">
              To request deletion of your account and associated data, you can:
            </p>
            <ul className="list-disc list-inside ml-4 mb-4 space-y-2">
              <li>Send an email to{" "}
                <a href="mailto:info@azucarmultimedia.com" className="text-blue-600 hover:text-blue-800 underline">
                  info@azucarmultimedia.com
                </a>{" "}
                with your deletion request
              </li>
              <li>Contact us through our support channels</li>
              <li>Use the account deletion option in your account settings (if available)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">What Data Will Be Deleted</h2>
            <p className="mb-4">
              When you request data deletion, we will remove:
            </p>
            <ul className="list-disc list-inside ml-4 mb-4 space-y-2">
              <li>Your personal information (name, email, phone number)</li>
              <li>Your account credentials and login information</li>
              <li>Your usage data and activity logs</li>
              <li>Any other personal data associated with your account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Data Retention</h2>
            <p className="mb-4">
              Some data may be retained for a limited period for legal or business purposes, such as:
            </p>
            <ul className="list-disc list-inside ml-4 mb-4 space-y-2">
              <li>Financial records required by law</li>
              <li>Data necessary for resolving disputes</li>
              <li>Information required for legal compliance</li>
            </ul>
            <p className="mb-4">
              Such data will be deleted once it is no longer required for these purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Processing Time</h2>
            <p className="mb-4">
              We will process your deletion request within 30 days of receiving it. You will receive 
              a confirmation email once your data has been deleted.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Consequences of Deletion</h2>
            <p className="mb-4">
              Please note that deleting your account and data is permanent and cannot be undone. 
              After deletion:
            </p>
            <ul className="list-disc list-inside ml-4 mb-4 space-y-2">
              <li>You will lose access to all services associated with your account</li>
              <li>You will not be able to recover any data or content</li>
              <li>You may need to create a new account if you wish to use our services again</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Third-Party Services</h2>
            <p className="mb-4">
              If you have used our services in connection with third-party services, you may need 
              to separately request data deletion from those services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact Us</h2>
            <p className="mb-4">
              If you have questions about data deletion or need assistance with your request, 
              please contact us at{" "}
              <a href="mailto:info@azucarmultimedia.com" className="text-blue-600 hover:text-blue-800 underline">
                info@azucarmultimedia.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserDataDeletion;

